import { useEffect, useContext, useState } from 'react';
import ExperienceContext from '../components/ExperienceContext';

let localizedStoreId;
export const useStoreId = ({ varnish = true, online = true } = {}) => {
  const { store, clientStore } = useContext(ExperienceContext);
  const cachedStoreId = online ? '8119' : '121';

  const [storeId, setStoreId] = useState(
    varnish && !localizedStoreId
      ? cachedStoreId
      : localizedStoreId || store?.storeId || cachedStoreId
  );

  useEffect(() => {
    if (clientStore?.storeId) {
      localizedStoreId = clientStore?.storeId;
      setStoreId(clientStore?.storeId);
    }
  }, [clientStore?.storeId]);

  return storeId;
};
